import * as React from "react";
import { AppShape } from "@eave/shared/types/api";
import Money from "web_modules/Money";
import * as moment from "moment";

interface CriticalDetailsProps {
  app: AppShape;
}

const asPct = num => `${(Number(num) * 100).toFixed(2)}%`;
const styles = require("./styles.module.scss");

const CriticalDetails: React.SFC<CriticalDetailsProps> = props => {
  const { computed_properties, decision, borrower1_tos_privacy_policy_accepted } = props.app;
  const {
    registration_date,
    application_date,
    ltv,
    ltv_purchase_price,
    ltv_avm,
  } = computed_properties;

  const closingCosts =
    Number(decision.min_downpayment_plus_closing_costs) - Number(decision.min_downpayment);
  const reserves =
    Number(decision.min_assets_required) - Number(decision.min_downpayment_plus_closing_costs);
  return (
    <dl className={styles.details}>
      <dt>Registration Date</dt>
      <dd>{registration_date && moment.utc(registration_date).format("MM-DD-YYYY")}</dd>
      <dt>Application Date </dt>
      <dd>{application_date && moment.utc(application_date).format("MM-DD-YYYY")}</dd>
      <dt>Loan Amount / Purchase Price</dt>
      <dd>{asPct(ltv_purchase_price)}</dd>
      <dt>Loan Amount / AVM </dt>
      <dd>{asPct(ltv_avm)}</dd>
      <dt>LTV</dt>
      <dd>{asPct(ltv)}</dd>
      <dt>Max LTV</dt>
      <dd>{asPct(decision.max_ltv)}</dd>
      <dt>CLTV </dt>
      <dd />
      <dt>Estimated Total Assets Required</dt>
      <dd>
        <Money value={Number(decision.min_assets_required)} />
      </dd>
      <dt>Estimated Downpayment </dt>
      <dd>
        <Money value={Number(decision.min_downpayment)} />
      </dd>
      <dt>Estimated Closing Costs</dt>
      <dd>
        <Money value={Number(closingCosts)} />
      </dd>
      <dt>Estimated Reserves</dt>
      <dd>
        <Money value={Number(reserves)} />
      </dd>
      <dt>Liability Reserves</dt>
      <dd>
        <Money value={Number(decision.liability_reserves)} />
      </dd>
      <dt>Terms of Service accepted</dt>
      <dd>{moment.utc(borrower1_tos_privacy_policy_accepted).format("M/D/YYYY h:mma Z")}</dd>
    </dl>
  );
};

export default CriticalDetails;
